import { Backdrop, CircularProgress } from "@mui/material";

interface Props {
  visible: boolean;
}

/**
 * 任意の要素に対してローディングマークを表示する。  
 * 親要素に position: "relative" を指定すること。  
 * 
 * @param visible 
 * @returns 
 */
export default function Loading({ visible }: Props) {
  return (
    <Backdrop
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%"
      }}
      sx={{
        color: "#fff",
        backgroundColor: "rgba(0, 0, 0, 0.2)",
        zIndex: (theme) => theme.zIndex.drawer + 1
      }}
      open={visible}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
